export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/questionGreenIcon.a1c8c8d8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};